module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 d-flex align-items-center justify-content-end"
  }, [_c('b-form-group', {
    staticClass: "m-0"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "primary",
      "title": "Importeer personen",
      "exact": "",
      "to": {
        name: 'personImport'
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "download"
    }
  })], 1), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "primary",
      "title": "Persoon toevoegen",
      "exact": "",
      "to": {
        name: 'personAdd'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  })]), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-secondary",
      "title": "Terug",
      "exact": "",
      "to": {
        name: 'Landingpage'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })])], 1)], 1)]), _vm._v(" "), (_vm.error) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-1 row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('filter-options', {
    attrs: {
      "person": ""
    },
    on: {
      "input": _vm.filterData
    },
    model: {
      value: (_vm.filterObj),
      callback: function($$v) {
        _vm.filterObj = $$v
      },
      expression: "filterObj"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 d-flex justify-content-end"
  }, [(_vm.persons.last_page > 1) ? _c('b-pagination-nav', {
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.persons.last_page,
      "value": _vm.persons.current_page,
      "use-router": "",
      "align": "right"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(!_vm.isFetching) ? _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "items": _vm.persons.data,
      "fields": _vm.fields,
      "per-page": parseInt(_vm.persons.per_page),
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "busy": _vm.isFetching,
      "empty-text": _vm.$t('person.listEmptyText'),
      "empty-filtered-text": _vm.$t('person.listEmptyFilteredText')
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function(row) {
        return [_c('b-btn-group', {
          staticClass: "pull-right"
        }, [_c('b-btn', {
          attrs: {
            "variant": "outline-primary",
            "to": {
              name: 'personEdit',
              params: {
                personId: row.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-edit"
        })])], 1)]
      }
    }], null, false, 3374525241)
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-pagination-nav', {
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.persons.last_page,
      "value": _vm.persons.current_page,
      "use-router": "",
      "align": "right"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6"
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Personen beheer")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58dff3b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Person/PersonList.vue
// module id = 1311
// module chunks = 1